<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="field">
        <label for="item_name">Choose Item</label>
        <select
          class="ui fluid search dropdown"
          id="item-search"
          v-model="itemDetailIndex"
        >
          <option value="all">All</option>
          <option :value="index" v-for="(itemDetail, index) in items" :key="index">
            {{ itemDetail.item.name }}
          </option>
        </select>
      </div>
    </div>
    
    <br>
    <div class="ui divider"></div>
    <br>

    <div>
      <div class="centered-header">
        <div class="ui two column grid"> 
            <div class="column"> 
              <div class="ui circular green segment" style="width: 150px; height: 150px;">
                <h2 class="ui header">
                  <div class="sub header">
                    Total Cost
                  </div>
                    {{ 
                      formatPrice(
                        itemDetailIndex === 'all' ?
                          totalCost : itemTotalCost(items[itemDetailIndex].invoice_entries)
                      ) 
                    }}
                </h2>
              </div>
            </div>
            <div class="column" v-if="itemDetailIndex !== 'all'"> 
              <div class="ui circular green segment" style="width: 150px; height: 150px;">
                <h2 class="ui header">
                  <div class="sub header">
                    Quantity
                  </div>
                  {{ 
                    itemRemainingQuantity(items[itemDetailIndex].invoice_entries)
                  }}
                </h2>
              </div>
            </div>
          </div>
      </div>
      <br>
      <abstractTable
        :columns="itemDetailIndex === 'all' ? allItemsColumns : ItemColumns"
        :data="itemDetailIndex === 'all' ? computedAllItems : computedItem()"
        :hasFooter="true"
        :classes="'ui very compact left aligned celled center aligned table'"
      >
        <template slot="footer">
          <th :colspan="itemDetailIndex === 'all' ? 3 : 4"></th>
          <th style="font-weight: bold;">
            {{ 
              formatPrice(
                itemDetailIndex === 'all' ?
                  totalCost : itemTotalCost(items[itemDetailIndex].invoice_entries)
              ) 
            }}
          </th>
        </template>
      </abstractTable>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  data() {
    return {
      items: [],
      loading: true,
      itemDetailIndex: 'all'
    }
  }, 
  mounted () {
    this.$http.get('/items/audit', {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.items = response.data
      this.loading = false
      this.initGUI()
    })
  },
  computed: {
    totalCost () {
      return window._.sumBy(this.items, detailItem => {
        return this.itemTotalCost(detailItem.invoice_entries)
      })
    },
    totalRemainingQuantity () {
      return window._.sumBy(this.items, detailItem => {
        return detailItem.item.quantity_in_stock
      })
    },
    allItemsColumns() {
      return [
        { header: 'Code', fieldName: 'system_code', show: true },
        { header: 'Name', fieldName: 'name', show: true },
        { header: 'Remaining Quantity', fieldName: 'remaining', show: true },
        { header: 'Total Cost', fieldName: 'total_cost', show: true }
      ];
    },
    ItemColumns() {
      return [
        { header: 'Label', fieldName: 'label', show: true },
        { header: 'Expired At', fieldName: 'expired_at', show: true },
        { header: 'Remaining Quantity', fieldName: 'remaining', show: true },
        { header: 'Unit Cost', fieldName: 'unit_price', show: true },
        { header: 'Total Cost', fieldName: 'total_cost', show: true }
      ];
    },
    computedAllItems() {
      let formlatedItems = [];

      window._.each(this.items, detailItem => {
        formlatedItems.push({
          system_code: detailItem.item.system_code,
          name: detailItem.item.name,
          remaining: this.itemRemainingQuantity(detailItem.invoice_entries),
          total_cost: this.formatPrice(this.itemTotalCost(detailItem.invoice_entries), 2)
        });
      });

      return formlatedItems;
    }
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#item-search').dropdown()
      })
    },
    itemTotalCost (invoiceEntries) {
      return window._.sumBy(invoiceEntries, invoiceEntry => {
        return Number(invoiceEntry.remaining) * Number(invoiceEntry.unit_price)
      })
    },
    itemRemainingQuantity(invoiceEntries) {
      return window._.sumBy(invoiceEntries, invoiceEntry => {
        return Number(invoiceEntry.remaining)
      })
    },
    computedItem() {
      let formlatedItems = [];

      window._.each(this.items[this.itemDetailIndex].invoice_entries,  invoiceEntry=> {
        formlatedItems.push({
          label: invoiceEntry.label,
          expired_at: invoiceEntry.expired_at ? 
            window.moment(invoiceEntry.expired_at).format('YYYY-MM-DD') : '-',
          remaining: invoiceEntry.remaining,
          unit_price: this.formatPrice(invoiceEntry.unit_price, 2),
          total_cost: this.formatPrice(invoiceEntry.unit_price * invoiceEntry.remaining, 2)
        });
      });

      return formlatedItems;
    }
  },
}
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/inventory_system/reports/Audit.vue